import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";

import ModalFooter from "../../../intelws_portal/constructs/modal/ModalFooter";
import ModalHeader from "../../../intelws_portal/constructs/modal/ModalHeader";
import ModalDatePicker from "../../../intelws_portal/constructs/modal/ModalDatePicker";
import ModalInputText from "../../../intelws_portal/constructs/modal/ModalInputText";
import ModalCommetText from "../../../intelws_portal/constructs/modal/ModalCommentText";
import { get, getCancelToken, post } from "../../../intelws_portal/utils/backendInterface";
import { parseQueryResponseOnFail, parseQueryResponseOnSuccess } from "../../../declarations/common_utils";
import { AxiosResponse } from "axios";
import { IFollowUpEvents } from "../common/LeadTracking";
import ModalDropDown from "../../../intelws_portal/constructs/modal/ModalDropDown";
import { IFetchUserListResponseRepr } from "../admin/AdminClientAction";
import { IDataRepr } from "../../../intelws_portal/constructs/elements/Table";

interface IEmployeeInfo {
    id: number,
    emp_full_name: string
}

interface IFetchEmployeeInfo {
    data: {
        data: IEmployeeInfo[];
    };
};

interface IPostLeadFollowUp extends AxiosResponse {
    data: {
        data: IDataRepr 
    }
}

export interface IModalLeadProps {
    userId: string,
    saveCallback: (data?: IDataRepr, success?: string[], fail?: string[]) => void,
    clearModal?: () => void
}

function ModalUserFollowup(props: IModalLeadProps) {
    const CLIENT_DASHBOARD_ENDPOINT = "/api/clientdashboard/";
    const ENDPOINT = "/api/userlist/";

    const [employeeInfo, setEmployeeInfo] = React.useState<IEmployeeInfo[]>([]);

    const [followUpType, setFollowUpType] = React.useState("");
    const [dueDate, setDueDate] = React.useState("");
    const [subject, setSubject] = React.useState("");
    const [description, setDescription] = React.useState("");
    const [empId, setEmpId] = React.useState(-1);
    const [disable, setDisable] = React.useState(true);

    const selectEmployeeText = React.useRef("Select Employee");

    const cancelTokenSource = React.useRef(getCancelToken());

    React.useEffect(() => {
        $("#followUpModal").on("hidden.bs.modal", clearForm);
        const queryParams = {
            section: "employee_info"
        }
        const requestResponse = get(CLIENT_DASHBOARD_ENDPOINT, cancelTokenSource.current.token, queryParams) as Promise<IFetchEmployeeInfo>;

        requestResponse.then((response) => {
            setEmployeeInfo(response.data.data);
            if (response.data.data.length == 1) {
                setEmpId(response.data.data[0].id);
            }
        })

        return () => {
            $("#followUpModal").off("hidden.bs.modal");
        }
    }, [])

    React.useEffect(() => {
        const isAllFieldsFilled = followUpType != "" && dueDate != "" && subject != "" && description != "" && empId != -1;
        setDisable(!isAllFieldsFilled);
    }, [followUpType, dueDate, subject, description, empId]);

    function clearForm() {
        setDueDate("");
        setSubject("");
        setDescription("");
        props.clearModal?.();
    }

    function submitForm() {
        const queryParams = {
            section: "add_follow_up"
        };

        const formData = new FormData();

        formData.append("user_id", props.userId.toString());
        formData.append("follow_up_type", followUpType);
        formData.append("subject", subject);
        formData.append("description", description);
        formData.append("follow_up_date", dueDate);
        formData.append("emp_id", empId.toString());

        const requestResponse = post(ENDPOINT, formData, cancelTokenSource.current.token, queryParams) as Promise<IPostLeadFollowUp>;
        requestResponse.then((response) => {
            let [success, fail] = parseQueryResponseOnSuccess(response);
            props.saveCallback(response.data.data, success, fail);
        }).catch((error) => {
            let [success, fail] = parseQueryResponseOnFail(error);
            props.saveCallback(undefined, success, fail);
        })
        .finally(() => {
            $("#followUpModal").modal("hide");
        })
    }
    
    function getModalContent() {
        const followUpTypeOptions = ["Select Type", "Notice", "Payroll", "Book Keeping", "Tax Planning", "Annual Report", "Misc"]
        const followUpTypeValues = ["", "notice", "payroll", "book_keeping", "tax_planning", "annual_report", "misc"]

        const employeeOptions = [selectEmployeeText.current, ...employeeInfo.map(employee => employee.emp_full_name)]
        const employeeValues = [-1, ...employeeInfo.map(employee => employee.id)]

        return (
            <React.Fragment>
                <ModalHeader title="Lead Follow Up Date" />
                <div className="modal-body">
                    <br />
                    <ModalDropDown options={followUpTypeOptions} values={followUpTypeValues} value={followUpType} onChange={(e) => setFollowUpType(e.target.value)} />
                    <br />
                    <ModalInputText title="Subject" value={subject} onChange={(e) => setSubject(e.target.value)} required />
                    <br />
                    <ModalCommetText title="Description" placeholder="Enter Follow Up Description Here" value={description} onChange={(e) => setDescription(e.target.value)} required />
                    <br />
                    <ModalDatePicker title="Follow Up Date" value={dueDate} onChange={(e) => setDueDate(e.target.value)} required/>
                    <br />
                    {employeeInfo.length > 1 &&
                        <ModalDropDown options={employeeOptions} values={employeeValues} onChange={(e) => setEmpId(parseInt(e.target.value))} required />
                    }
                </div>
                <ModalFooter saveCallback={submitForm} saveInactive={false} disable={disable}/>
            </React.Fragment>
        )
    }
    function relativeRender() {
        return <div className="modal fade custom-modal text-center" id="followUpModal" tabIndex={-1}>
                <div className="modal-dialog text-left modal-lg">
                    <div className="modal-content">
                        {getModalContent()}
                    </div>
                </div>
            </div>
    }
    
    return ReactDOM.createPortal(relativeRender(), document.getElementById("modal") as Element);
}

export default ModalUserFollowup;